// routes.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import Staff from "./pages/Staff";
import Inscriptions from "./pages/Inscriptions";
import Contact from "./pages/Contact";
import IlesDePaix from "./pages/IlesDePaix";
import Login from "./pages/Login";
import EditStaff from "./pages/EditStaff";

const AppRoutes = () => (
    <Router>
        <Routes>
            <Route path="/" element={<LandingPage />} />
        </Routes>
        <Routes>
            <Route path="/Staff/:id" element={<Staff />} />
        </Routes>
        <Routes>
            <Route path="/Inscription" element={<Inscriptions />} />
        </Routes>
        <Routes>
            <Route path="/Contact" element={<Contact />} />
        </Routes>
        <Routes>
            <Route path="/IlesDePaix" element={<IlesDePaix />} />
        </Routes>
        <Routes>
            <Route path="/Login" element={<Login />} />
        </Routes>
        <Routes>
            <Route path="/Edit/:id" element={<EditStaff />} />
        </Routes>

    </Router>
);

export default AppRoutes;
